import { render, staticRenderFns } from "./TeacherApprovals.vue?vue&type=template&id=6e3c63da&scoped=true"
import script from "./TeacherApprovals.vue?vue&type=script&lang=js"
export * from "./TeacherApprovals.vue?vue&type=script&lang=js"
import style0 from "./TeacherApprovals.vue?vue&type=style&index=0&id=6e3c63da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c63da",
  null
  
)

export default component.exports